// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__5nSea","overlay":"Modal_overlay__y6WIl","content":"Modal_content__iORRF","opened":"Modal_opened__dJHcJ","isClosing":"Modal_isClosing__Z3cdD"};